import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-lgpd',
  templateUrl: './lgpd.component.html',
  styleUrls: ['./lgpd.component.css']
})
export class LgpdComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
